<template>
  <div class="video">
    <div class="video__details">
      <button
        @click="$emit('toggleWatched')"
        class="video__icon-wrapper"
        v-tooltip="{
          content: 'Toggle Progress',
          placement: 'right-center',
        }"
      >
        <VideoIcon
          :fill="hasWatched ? '#00DEA0' : '#808080'"
          class="video__icon"
        />
      </button>
      <div class="video__duration-wrapper">
        <p class="video__duration">
          {{ $duration.durationOn(video.duration) }}
        </p>
      </div>
    </div>
    <div class="video__player-wrapper">
      <VideoPlayer
        v-if="isWatching"
        :video="video"
        :nextContent="nextContent"
        @advanceToNextVideo="$emit('advanceToNextVideo')"
        @isLoadingVideo="updateLoader"
      ></VideoPlayer>
    </div>
  </div>
</template>

<script>
import VideoIcon from '@/assets/icons/course/video_icon.svg'
import VideoPlayer from '@/components/course/content/level/VideoPlayer.vue'

export default {
  name: 'Video',
  components: {
    VideoIcon: { ...VideoIcon, name: 'VideoIcon' },
    VideoPlayer,
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
    isWatching: {
      type: Boolean,
      required: true,
    },
    hasWatched: {
      type: Boolean,
      required: true,
    },
    quizId: {
      type: String,
      required: false,
    },
    hasPassedQuiz: {
      type: Boolean,
      required: false,
    },
    nextVideo: {
      type: [Object, null],
      required: false,
    },
  },
  computed: {
    nextContent() {
      if (this.quizId && this.quizId.length && !this.hasPassedQuiz) {
        return 'quiz'
      }
      if (this.nextVideo) {
        return 'video'
      }
      return ''
    },
  },
  methods: {
    updateLoader(e) {
      this.$emit('isLoadingVideo', e)
    },
  },
}
</script>

<style lang="scss" scoped>
.video {
  $this: &;
  margin: 0 auto 50px 0;
  transition: 1s all ease;
  position: relative;
  &__details {
    display: flex;
    align-items: center;
    margin: 20px 0 20px 0;
  }
  &__icon-wrapper {
    background: var(--light-gray);
    height: 62px;
    width: 62px;
    margin: 0 5px 0 0;
    border: none;
    cursor: pointer;
  }
  &__icon {
    vertical-align: middle;
  }
  &__duration-wrapper {
    display: flex;
    align-items: center;
    margin: 5px 0 0 50px;
  }
  &__duration {
    color: var(--white);
  }
  &__player-wrapper {
    @include desktop {
      padding: 0 50px 0 50px;
    }
  }
}
</style>
